<template>
  <div class="room-fee-import-detail-container animated fadeInRight">
    <!-- 查询条件 -->
    <el-card class="search-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('roomFeeImportDetail.search.title') }}</span>
        <el-button type="text" size="small" @click="toggleMoreCondition">
          {{ showMoreCondition ? $t('roomFeeImportDetail.search.hideCondition') : $t('roomFeeImportDetail.search.moreCondition') }}
        </el-button>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input v-model="searchForm.floorNum" :placeholder="$t('roomFeeImportDetail.search.floorNum')" clearable />
        </el-col>
        <el-col :span="6">
          <el-input v-model="searchForm.unitNum" :placeholder="$t('roomFeeImportDetail.search.unitNum')" clearable />
        </el-col>
        <el-col :span="6">
          <el-input v-model="searchForm.roomNum" :placeholder="$t('roomFeeImportDetail.search.roomNum')" clearable />
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="handleSearch">
            {{ $t('common.search') }}
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <!-- 导入费用详情列表 -->
    <el-card class="table-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('roomFeeImportDetail.table.title') }}</span>
        <el-button type="primary" @click="goBack">
          {{ $t('roomFeeImportDetail.button.back') }}
        </el-button>
      </div>

      <el-table :data="tableData" border style="width: 100%" v-loading="loading">
        <el-table-column prop="floorNum" :label="$t('roomFeeImportDetail.table.floorNum')" align="center" />
        <el-table-column prop="unitNum" :label="$t('roomFeeImportDetail.table.unitNum')" align="center" />
        <el-table-column prop="roomNum" :label="$t('roomFeeImportDetail.table.roomNum')" align="center" />
        <el-table-column prop="feeName" :label="$t('roomFeeImportDetail.table.feeName')" align="center" />
        <el-table-column prop="startTime" :label="$t('roomFeeImportDetail.table.startTime')" align="center" />
        <el-table-column prop="endTime" :label="$t('roomFeeImportDetail.table.endTime')" align="center" />
        <el-table-column prop="amount" :label="$t('roomFeeImportDetail.table.amount')" align="center" />
        <el-table-column prop="remark" :label="$t('roomFeeImportDetail.table.remark')" align="center" />
        <el-table-column :label="$t('roomFeeImportDetail.table.state')" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.state === '1000'" type="success">
              {{ $t('roomFeeImportDetail.status.success') }}
            </el-tag>
            <el-tag v-else type="danger">
              {{ $t('roomFeeImportDetail.status.failed') }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination 
        :current-page="pagination.current" 
        :page-sizes="[10, 20, 30, 50]" 
        :page-size="pagination.size"
        :total="pagination.total" 
        layout="total, sizes, prev, pager, next, jumper" 
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange" 
      />
    </el-card>
  </div>
</template>

<script>
import { queryImportFeeDetail } from '@/api/fee/roomFeeImportDetailApi'
import {getCommunityId} from '@/api/community/communityApi'

export default {
  name: 'RoomFeeImportDetail',
  data() {
    return {
      loading: false,
      showMoreCondition: false,
      searchForm: {
        floorNum: '',
        unitNum: '',
        roomNum: '',
        importFeeId: ''
      },
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    console.log('RoomFeeImportDetail created')
    this.initData()
  },
  methods: {
    initData() {
      // 从路由参数获取 importFeeId
      this.searchForm.importFeeId = this.$route.query.importFeeId
      this.getList()
    },
    async getList() {
      try {
        this.loading = true
        const params = {
          page: this.pagination.current,
          row: this.pagination.size,
          importFeeId: this.searchForm.importFeeId,
          floorNum: this.searchForm.floorNum,
          unitNum: this.searchForm.unitNum,
          roomNum: this.searchForm.roomNum,
          communityId: getCommunityId()
        }
        const { data, total } = await queryImportFeeDetail(params)
        this.tableData = data
        this.pagination.total = total
      } catch (error) {
        this.$message.error(this.$t('roomFeeImportDetail.message.fetchError'))
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.current = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.getList()
    },
    toggleMoreCondition() {
      this.showMoreCondition = !this.showMoreCondition
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.room-fee-import-detail-container {
  padding: 20px;

  .search-card {
    margin-bottom: 20px;
  }

  .table-card {
    margin-bottom: 20px;
  }
}
</style>
